import { inject, PipeTransform } from '@angular/core';
import { LocaleService } from '../services/locale/locale.service';

export type TranslationLanguage = 'en' | 'pt' | 'es';

export type Translation<Keyset extends string> = { [k in Keyset]: string };
export type TranslationSet<Keyset extends string> = {
  [lang in TranslationLanguage]: Translation<Keyset>;
};

export abstract class TranslatePipe<Keyset extends string>
  implements PipeTransform
{
  abstract get translations(): TranslationSet<Keyset>;

  private lang = inject(LocaleService).getCurrentLanguage();

  transform(value: Keyset) {
    return this.translations[this.lang][value];
  }
}
